import { create } from 'zustand'

interface ChatNotificationState {
    /** Unseen USER-CHAT messages (drives the taskbar "messages" badge). */
    unreadCount: number
    setUnreadCount: (value: number) => void
    /** Unseen AI-assistant messages (drives the taskbar AI badge). Mirrored here by ChatApp while
     *  the panel is open - nothing outside the panel can know about an assistant message or a
     *  monitoring alert, so it is 0 whenever the panel has not been opened. */
    agentUnread: number
    setAgentUnread: (value: number) => void
}

/**
 * Lightweight global counter driving the "messages waiting" badge on the
 * AI Assistant icon in the top taskbar. Kept in sync by GlobalChatNotifications
 * (seeded from the unread API, updated live from socket `unread-update` events).
 */
export const useChatNotificationStore = create<ChatNotificationState>((set) => ({
    unreadCount: 0,
    setUnreadCount: (value) => set({ unreadCount: Math.max(0, value) }),
    agentUnread: 0,
    setAgentUnread: (value) => set({ agentUnread: Math.max(0, value) }),
}))
